import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import type { UtilisateurType } from '@/types';

interface UtilisateurListeTableRowProps {
  item: UtilisateurType;
  rowProps: Record<string, unknown>;
}

const UtilisateurListeTableRow = (props: UtilisateurListeTableRowProps) => {
  const { item, rowProps } = props;

  const { identifiant, nom, prenom } = item;

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="nom"
        // @ts-expect-error
        title={nom}
      >
        {_.trim(`${nom || ''} ${prenom || ''}`)}
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default UtilisateurListeTableRow;
